import { Row, Container } from 'react-bootstrap';
import { Html } from '../../Component/Commons';
import { Icon2 } from '../../Component/Icons/IconSelector';
export function Servicios({ data: { id, itens, props } }: any) {
    const { color, gap } = props;
    return <Row className='m-0' style={{ backgroundColor: color, padding: '10px 0 10px 0' }}>
        <Container style={{ display: 'grid', gap: `${gap}px`, gridAutoFlow: 'dense', gridTemplateColumns: `repeat(auto-fill, minmax(320px, 1fr))` }}>
            {itens.map((i: any) => <Itens key={`iten${id}${i.id}`} iten={i} config={props} />)}
        </Container>
    </Row>
}
function Itens({
    config: { card, border1, border2, back: iback, orientation, font },
    iten: { html, props: { icon, color, back, aux, fill, aling } } }: any) {
    const style = {
        border: (border1) ? `5px solid ${fill}` : undefined,
        backgroundColor: card !== 'none' ? back : undefined,
        borderRadius: card === 'rounded' ? `${font / 3}rem` : undefined,
        padding: '10px 10px 10px 10px'
    };
    const className = orientation.indexOf('column') > -1 ? "d-flex justify-content-center" : "d-flex align-items-center h-100";
    return <div style={style} className={`d-flex flex-${orientation}`}>
        <div className={className}>
            <Icon2 icon={icon} font={font} fill={fill} back={iback} border={border2} aux={aux} />
        </div>
        <Html style={{ color }} html={html} className="caption d-flex align-items-center h-100 p-1" />
    </div>
}